const navigation = [
    {
        selector: '[data-navigation-type^=btf]',
        path: { filename: 'btf/navigationSecondary' },
    },
    {
        selector: '[data-navigation-type=btf-mobile]',
        path: { filename: 'btf/navigationMobile' },
    },
    {
        selector: '[data-navigation-type=btf-desktop]',
        path: { filename: 'btf/navigationDesktop' },
    },
    {
        selector: 'footer.footer-contentinfo',
        path: { filename: 'navigationFooter' },
    },
];

export { navigation };
